module.exports = __webpack_public_path__ + "static/media/coinwrap_logo.5fe20691.png";